<template>
    <div>
        <ly-crud ref="lycrud"  v-bind="crudConfig" >
            <template v-slot:customHandle="slotProps">
                <span class="table-operate-btn" @click="handleClick(slotProps.row,'disable')" v-show="hasPermission(this.$route.name,'Disable')">
                    <span v-if="slotProps.row.is_active">禁用</span>
                    <span v-else>启用</span>
                </span>
            </template>
        </ly-crud>
    </div>
</template>

<script lang="jsx">
    import {eqManageHisData} from '@/api/api'
    import LyCrud from "@/components/lycrud_eq_hisdata";
    import templateData from "@/components/dict/crudTemplateData"
    import { h,resolveComponent } from 'vue';
    export default {
        name: "eqManage",
        components: {LyCrud},
        data(){
            return{
                defaultImg:require('../../assets/img/avatar.jpg'),
                //crud配置
                crudConfig:{
                    //crud请求方法配置
                    crudRequest:{
                        search:eqManageHisData,
                    },
                    //搜索栏目配置
                    searchBar:{
                        showSearchBar:true,//显示搜索栏目
                        searchColums:[
                            {label:'数据类型',type:'select',prop:'data_type',width:100,placeholder:'请选择',
                                options:[
                                    {value:1,label:'设备数据'},
                                    {value:2,label:'显示数据'},
                                    {value:3,label:'设置数据'},
                                    {value:4,label:'诊断数据'},
                                    {value:5,label:'服务数据'},
                                    {value:6,label:'后台数据'},
                                    {value:7,label:'曲线数据'}
                                ]
                            },
                            {label:'序列号',type:'input',prop:'serial_num',width:200,maxlength:60,placeholder:'请输入序列号'},
                            {label:'操作时间',type:'datepicker-datetimerange',prop:'dates'},
                        ]
                    },
                    //显示分页
                    showPagination:true,
                    //分页配置
                    pageparams: {
                        limit: 10,//每页显示的条数(默认每页显示10条)//非必填
                        //pageSizes:[10,20,30,40,50,200],//非必填
                        // layout:'total, sizes, prev, pager, next, jumper',//非必填
                    },
                    //crud按钮配置
                    
                    //crud弹窗属性
                    formOptions: {
                        width:'45%',//dialog弹窗宽度：类型：百分比或字符串
                        gutter: 20, // Layout布局栅格间隔
                    },
                    //crud表格属性
                    tableOptions:{
                        border:true,
                        showHeader:true,
                    },
                    showSelectable:false,//表格显示复选项框
                    tableColumns:[
                        {label:'更新时间',prop:'change_time',minWidth:'150',sortable: false,hidden:false },
                         {label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false },
                         {label:'设备类型',prop:'device_type',minWidth:'200',sortable: false,hidden:false},
                        {label:'在线状态',prop:'onlineflag',minWidth:'100',sortable: false,hidden:false},
                         {label:'创建时间',prop:'creted_time',minWidth:'130',sortable: false,hidden:false,},
                         {label:'最后更新时间',prop:'update_time',minWidth:'100',sortable: false,hidden:false},
                         {label:'LOGO',prop:'logo',minWidth:'150',sortable: false,hidden:false},
                         {label:'生产日期',prop:'product_date',minWidth:'100',sortable: false,hidden:false},
                         {label:'软件版本',prop:'soft_ver',minWidth:'100',sortable: false,hidden:false},],
                    //table表头列
                    
                },

            }
        },
        onshow(){
        },
        methods:{
            setFull(){
                this.$refs.lycrud.setFull()
            },
            //自定义操作列按钮方法
            handleClick(row,flag){
                console.log("test2222")
                if(flag=='disable'){
                    UsersUsersdisableEdit({id:row.id}).then(res=>{
                        if(res.code == 2000) {
                            vm.$message.success(res.msg)
                            vm.$refs.lycrud.handleRefresh()//刷新表格数据
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                }
            },
        },
    }
</script>

<style scoped>

</style>